const userType = {
    AGENCY_BROKERAGE : 1,

    SERVICE : 2,

    SYSTEM : 3,

    UNDERWRITER : 4

};

angular.module('gw-um-j2js')
    .constant('userType', userType);